<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-ministry-sidebar></app-ministry-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div class="card shadow m-3" style="width: 100%">
              <div
                class="
                  card-header
                  heading_n_button_box
                  card-header-cus-new-appoint
                "
              >
                <div class="card-heading">
                  <h4>List of Vaccination Passports</h4>
                </div>

                <div class="button-section mt-1"></div>
              </div>

              <div class="card-body">
                <div class="col-lg-12">
                  <div class="col-lg-12">
                    <form
                      [formGroup]="searchForm"
                      (ngSubmit)="onSubmitSearch(searchForm.value)"
                    >
                      <div class="form-row">
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="passengerName"
                            placeholder="Passenger Name"
                            formControlName="passengerName"
                            id="passengerName"
                          />
                        </div>
                        <div class="col">
                          <input
                            class="form-control font-12"
                            name="email"
                            placeholder="Email"
                            formControlName="email"
                            id="email"
                          />
                        </div>
                        <div class="col">
                          <select
                            class="form-control font-12"
                            name="status"
                            formControlName="status"
                            id="status"
                          >
                            <option value="">Status</option>
                            <option value="PENDING">PENDING</option>
                            <option value="APPROVED">APPROVED</option>
                            <option value="REJECTED">REJECTED</option>
                          </select>
                        </div>

                        <div class="col">
                          <div class="mr-4">
                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                              "
                              type="submit"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i class="fas fa-search"></i> Search
                            </button>

                            <button
                              class="
                                btn btn-secondary
                                theme-btn-2
                                dropdown-toggle-no
                                ml-2
                              "
                              type="button"
                              id="dropdownMenuButton"
                              aria-haspopup="true"
                              aria-expanded="false"
                              (click)="clearSearch()"
                            >
                              <i class="fas fa-sync-alt"></i> Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="">
                    <div class="table-responsive mt-3">
                      <div class="col-auto">
                        <div class="row" *ngIf="vaccinationPassports">
                          <div class="show-record mt-3 mbm-32">
                            <span>Show</span> &nbsp;
                            <select
                              class="
                                custom-select custom-select-sm
                                form-control form-control-sm
                              "
                              (change)="setItemsPerPage(page.value)"
                              #page
                            >
                              <option [selected]="currentPageLength == 10">
                                10
                              </option>
                              <option [selected]="currentPageLength == 30">
                                30
                              </option>
                              <option [selected]="currentPageLength == 50">
                                50
                              </option>
                              <option [selected]="currentPageLength == 100">
                                100
                              </option>
                              <option [selected]="currentPageLength == 500">
                                500
                              </option>
                              <option [selected]="currentPageLength == 1000">
                                1000
                              </option>
                            </select>
                            &nbsp;
                            <span> entries</span>
                          </div>
                        </div>
                      </div>

                      <table
                        *ngIf="vaccinationPassports"
                        class="
                          table
                          table-bordered
                          table-condensed
                          table-responsive-sm
                          table-responsive-md
                          table-responsive-lg
                          table-responsive-xl
                          nowrap
                        "
                        datatable
                        [dtOptions]="dtOptions"
                        width="100%"
                      >
                        <thead class="">
                          <tr>
                            <th scope="col">S/N</th>
                            <th scope="col">Passenger Name</th>
                            <th scope="col">First Dose</th>
                            <th scope="col">Second Dose</th>
                            <th scope="col">Phone Number</th>
                            <th scope="col">Email</th>
                            <th scope="col">Gender</th>
                            <th scope="col">Status</th>
                            <th scope="col">Country Vaccinated</th>
                            <th scope="col">Vaccination Center</th>
                            <th scope="col">Vaccine</th>
                            <th scope="col">Date Of Birth</th>

                            <!-- <th scope="col">Date Of Departure</th>
                            <th scope="col">Scheduled Date For COVID Test</th> -->
                            <!-- <th scope="col">Address</th> -->
                            <!-- <th scope="col">Airline</th>                            -->
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody class="dashboard-bg-white">
                          <tr
                            *ngFor="
                              let result of vaccinationPassports
                                | paginate: config;
                              index as i
                            "
                          >
                            <th scope="row">
                              {{
                                config.itemsPerPage * (config.currentPage - 1) +
                                  i +
                                  1
                              }}
                            </th>
                            <td>
                              {{ result.full_name }}
                            </td>
                            <td>{{ result.first_dose_date }}</td>
                            <td>{{ result.second_dose_date }}</td>
                            <td>{{ result.phone }}</td>
                            <td>{{ result.email }}</td>
                            <td>{{ result.gender }}</td>
                            <td>
                              <span
                                *ngIf="result.status == 'PENDING'"
                                class="text-warning"
                                >{{ result.status }}</span
                              >
                              <span
                                *ngIf="result.status == 'APPROVED'"
                                class="text-success"
                                >{{ result.status }}</span
                              >
                              <span
                                *ngIf="result.status == 'REJECTED'"
                                class="text-danger"
                                >{{ result.status }}</span
                              >
                            </td>
                            <td>{{ result.vaccination_country }}</td>
                            <td>{{ result.vaccination_place }}</td>
                            <td>{{ result.vaccine_name }}</td>
                            <td>{{ result.dob }}</td>
                            <!-- <td>{{ result.created_at | date: "medium" }}</td> -->
                            <th>
                              <button
                                class="btn-view"
                                type="button"
                                (click)="showDetails(showmodal, result)"
                                title="View Details"
                              >
                                <i class="far fa-eye"></i>
                              </button>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      <div class="table-footer">
                        <div
                          id="page_info"
                          class="mt-3 record-show-text-bottom"
                          *ngIf="vaccinationPassports"
                        >
                          Showing
                          {{
                            (config.currentPage - 1) * config.itemsPerPage + 1
                          }}
                          - {{ config.currentPage * config.itemsPerPage }} of
                          {{ config.totalItems }} entries
                        </div>

                        <div
                          class="pagination paging-pull-right"
                          *ngIf="vaccinationPassports"
                        >
                          <pagination-controls
                            (pageChange)="pageChange($event)"
                            class="my-pagination mt-2 pagination-server"
                          >
                          </pagination-controls>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #showmodal let-modal>
  <div class="row">
    <div class="col-lg-12 mb-3">
      <div
        class="
          card-header
          col-lg-12
          heading_n_button_box
          header-dashboard-button-2
        "
      >
        <h3>{{ passenger.full_name | titlecase }} Vaccination Passport</h3>
        <button class="close-button" (click)="modal.close('Save click')">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="card-body p-4">
        <div class="container">
          <dl class="row">
            <dt class="col-sm-5">Passenger Name</dt>
            <dd class="col-sm-7">{{ passenger?.full_name | titlecase }}</dd>
            <dt class="col-sm-5">Phone Number</dt>
            <dd class="col-sm-7">{{ passenger?.phone }}</dd>
            <dt class="col-sm-5">Email</dt>
            <dd class="col-sm-7">{{ passenger?.email }}</dd>
            <dt class="col-sm-5">Gender</dt>
            <dd class="col-sm-7">{{ passenger?.gender | titlecase }}</dd>
            <dt class="col-sm-5">Date of birth</dt>
            <dd class="col-sm-7">{{ passenger?.dob }}</dd>
            <dt class="col-sm-5">Vaccination Center</dt>
            <dd class="col-sm-7">{{ passenger?.vaccination_place }}</dd>
            <dt class="col-sm-5">Country Vaccinated</dt>
            <dd class="col-sm-7">{{ passenger?.vaccination_country }}</dd>
            <dt class="col-sm-5">Vaccine Collected</dt>
            <dd class="col-sm-7">{{ passenger?.vaccine_name }}</dd>
            <dt class="col-sm-5">Status</dt>
            <dd class="col-sm-7">
              <p *ngIf="passenger?.status == 'PENDING'" class="text-warning">
                {{ passenger?.status }}
              </p>
              <p *ngIf="passenger?.status == 'APPROVED'" class="text-success">
                {{ passenger?.status }}
              </p>
              <p *ngIf="passenger?.status == 'REJECTED'" class="text-danger">
                {{ passenger?.status }}
              </p>
            </dd>
            <dt class="col-sm-5">Date Submitted</dt>
            <dd class="col-sm-7">
              {{ passenger?.created_at | date: "ddd MMM, yyyy" }}
            </dd>
            <dt class="col-sm-5">First Dose Date</dt>
            <dd class="col-sm-7">{{ passenger?.first_dose_date }}</dd>
            <dt class="col-sm-5">First Dose Certificate</dt>
            <dd class="col-sm-7">
              <a target="_blank" [href]="passenger?.first_dose_filepath"
                ><img
                  [src]="passenger?.first_dose_filepath"
                  style="width: 200px; height: 300px"
              /></a>
            </dd>
            <dt class="col-sm-5">Second Dose Date</dt>
            <dd class="col-sm-7">{{ passenger?.second_dose_date }}</dd>
            <dt class="col-sm-5">Second Dose Certificate</dt>
            <dd class="col-sm-7">
              <a target="_blank" [href]="passenger?.second_dose_filepath"
                ><img
                  [src]="passenger?.second_dose_filepath"
                  style="width: 200px; height: 300px"
              /></a>
            </dd>

            <dt class="col-sm-5">Recovery Certificate</dt>
            <dd
              class="col-sm-7"
              *ngIf="passenger?.negative_report; else else_content"
            >
              <a target="_blank" [href]="passenger?.negative_report">
                <img
                  [src]="passenger?.negative_report"
                  style="width: 200px; height: 300px"
                />
              </a>
            </dd>
            <ng-template #else_content>
              <dd class="col-sm-7">N/A</dd>
            </ng-template>
            <!-- <ng-template #else_content>N/A</ng-template> -->
          </dl>
        </div>
        <div class="col-md-12 mt-3 mb-4 text-center mx-auto">
          <button
            *ngIf="passenger?.status == 'PENDING'"
            (click)="isAction('APPROVED', passenger?.id)"
            class="btn btn-secondary theme-btn-2 dropdown-toggle-no"
          >
            Approve
          </button>
          <button
            *ngIf="passenger?.status == 'PENDING'"
            (click)="selectRejectionReason = true"
            class="btn btn-secondary theme-btn-2 dropdown-toggle-no ml-2"
          >
            Reject
          </button>
        </div>

        <div *ngIf="selectRejectionReason">
          <div class="col-md-12 mt-3 mb-4 text-center mx-auto">
            <div class="form-row">
              <div class="form-group col-md-6 mt-2 mb-2 offset-md-5">
                <div class="row card-valid">
                  <div class="expiry-month">
                    <select class="form-control" id="rejectReason">
                      <option selected>Select Reason</option>
                      <option
                        *ngFor="let reason of rejectionReasons"
                        value="{{ reason.id }}"
                      >
                        {{ reason.description }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 mt-3 mb-4 text-center mx-auto">
            <button
              *ngIf="passenger?.status == 'PENDING'"
              (click)="isAction('REJECTED', passenger?.id)"
              class="btn btn-secondary theme-btn-2 dropdown-toggle-no ml-2"
            >
              Reject Now
            </button>
            <button
            *ngIf="passenger?.status == 'PENDING'"
            (click)="selectRejectionReason = false"
            class="btn btn-danger dropdown-toggle-no ml-2"
          >
            Cancel
          </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-footer-dashboard></app-footer-dashboard>
